import fr from 'facet-rest';
import PropTypes from 'prop-types';
import React from 'react';
import {
  TaxDiagnosticHeaderLottie,
} from './TaxDiagnosticHeaderLottie';

export const TaxDiagnosticHeaderLottiePicker = ({ resource }) => {
  return resource.withRelationship(fr.relationships.headerLottie.name,
    (rel) => <TaxDiagnosticHeaderLottie src={rel.link('related').url()} />,
    () => null);
};

TaxDiagnosticHeaderLottiePicker.propTypes = {
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};
